import { faker } from '@faker-js/faker';
import { define } from 'cooky-cutter';
import { Account } from '../types';

export const accountFactory = define<Account>({
  id: () => faker.string.uuid(),
  name: () => faker.lorem.word(3),
  externalId: () => faker.string.uuid(),
});
